<template>

  <div class="container section">
    <div class="row heading">
      <div class="col">
        <h2>Commissions</h2>
      </div>
      <div class="col-6 text-right">
        <dropdown-confirmation
          v-if="!agentProfile.is_channel"
          triggerBtnClass="btn-primary"
          triggerBtnHtml='<i class="fa fa-plus"></i>&nbsp;&nbsp;Add Carrier Exception'
          confirmBtnClass="btn-success"
          confirmBtnHtml='<i class="fa fa-check"></i>&nbsp;&nbsp;Save'
          @confirm="saveNewCarrierOverride"
        >
          <slot>
            <autocomplete placeholder="Choose Carrier" :list="carrierNames" :selection="selectedOverrideCarrierName" @change="setNewOverrideCarrier"></autocomplete>
          </slot>
        </dropdown-confirmation>
      </div>
    </div>

    <br />
    <!-- Default Section -->


    <div v-for="c in agentCommissions" class="row commission-section" :class="{active: isActive(c)}">
      <div class="col-6 section-header" @click.stop="setActive(c)">

        <strong><i class="fa fa-caret-right" /> &nbsp;{{c.carrier_name | uppercase}}</strong>
      </div>
      <div class="col-6 text-right">
        <button @click="editComms(c)" v-show="isActive(c) && selectedComms.carrier_name != c.carrier_name"  class="btn btn-sm btn-primary"><i class="fa fa-gear"></i>&nbsp;&nbsp;Edit</button>

        <dropdown-confirmation
                v-show="isActive(c) && selectedComms.carrier_name != c.carrier_name"
                triggerBtnHtml='<i class="fa fa-trash"></i>&nbsp;&nbsp;Delete'
                @confirm="deleteComms(c)"
        >
          <slot>
            Are you sure you want to delete this exception?  This change cannot be undone.
          </slot>
        </dropdown-confirmation>


        <button @click="saveComms()" v-show="isActive(c) && selectedComms.carrier_name == c.carrier_name"  class="btn btn-sm btn-success"><i class="fa fa-check"></i>&nbsp;&nbsp;Save</button>
        <button @click="selectedComms = {};" v-show="isActive(c) && selectedComms.carrier_name == c.carrier_name" class="btn btn-sm btn-clear">Cancel</button>
      </div>

      <div class="container">
        <div class="row"  v-if="agentProfile.is_channel">
          <label class="col-5 col-sm-7 col-md-3 col-lg-2 col-form-label">Sandler Comms</label>
          <div class="col-7 col-sm-5 col-md-3 col-lg-2">

            <div v-show="!selectedComms || selectedComms.carrier_name != c.carrier_name" class="col-form-label"> {{c.sandler_commsrate}} %</div>

            <div class="input-group" v-show="selectedComms.carrier_name == c.carrier_name">
              <input type="text" class="form-control" v-model="selectedComms.sandler_commsrate" />
              <div class="input-group-addon">
                %
              </div>
            </div>
          </div>
          <label class="col-5 col-sm-7 col-md-3 col-lg-2 col-lg-2  offset-lg-2 col-form-label">Sandler Spiff</label>
          <div class="col-7 col-sm-5 col-md-3 col-lg-2">

            <div v-show="!selectedComms || selectedComms.carrier_name != c.carrier_name" class="col-form-label"> {{c.sandler_spiffrate}} %</div>

            <div class="input-group" v-show="selectedComms.carrier_name == c.carrier_name">
              <input type="text" class="form-control" v-model="selectedComms.sandler_spiffrate" />
              <div class="input-group-addon">
                %
              </div>
            </div>
          </div>
        </div>

        <div class="row comm-tiers"  v-if="!agentProfile.is_channel">

          <label class="col-5 col-sm-7  col-md-3 col-lg-2 col-form-label">Tier 1 Comms</label>
          <div class="col-7 col-sm-5 col-md-3 col-lg-2">

            <div v-show="!selectedComms || selectedComms.carrier_name != c.carrier_name" class="col-form-label"> {{c.tier1_commsrate}} %</div>


            <div class="input-group"  v-show="selectedComms.carrier_name == c.carrier_name">
              <input type="text" class="form-control" v-model="selectedComms.tier1_commsrate" />
              <div class="input-group-addon">
                %
              </div>
            </div>
          </div>

          <label class="col-5 col-sm-7 col-md-3 col-lg-2 col-lg-2 offset-lg-2 col-form-label">Tier 1 Spiff</label>

          <div class="col-7 col-sm-5 col-md-3 col-lg-2">
            <div v-show="!selectedComms || selectedComms.carrier_name != c.carrier_name" class="col-form-label"> {{c.tier1_spiffrate}} %</div>
            <div class="input-group" v-show="selectedComms.carrier_name == c.carrier_name">
              <input type="text" class="form-control" v-model="selectedComms.tier1_spiffrate" />
              <div class="input-group-addon">
                %
              </div>
            </div>
          </div>


          <div class="w-100"></div>

          <label class="col-5 col-sm-7 col-md-3 col-lg-2 col-form-label">Tier 2 Comms</label>
          <div class="col-7 col-sm-5 col-md-3 col-lg-2">

            <div v-show="!selectedComms || selectedComms.carrier_name != c.carrier_name" class="col-form-label"> {{c.tier2_spiffrate}} %</div>

            <div class="input-group" v-show="selectedComms.carrier_name == c.carrier_name">
              <input type="text" class="form-control" v-model="selectedComms.tier2_commsrate" />
              <div class="input-group-addon">
                %
              </div>
            </div>
          </div>
          <label class="col-5 col-sm-7 col-md-3 col-lg-2 col-lg-2 offset-lg-2 col-form-label">Tier 2 Spiff</label>
          <div class="col-7 col-sm-5 col-md-3 col-lg-2">

            <div v-show="!selectedComms || selectedComms.carrier_name != c.carrier_name" class="col-form-label"> {{c.tier2_spiffrate}} %</div>

            <div class="input-group" v-show="selectedComms.carrier_name == c.carrier_name">
              <input type="text" class="form-control" v-model="selectedComms.tier2_spiffrate" />
              <div class="input-group-addon">
                %
              </div>
            </div>
          </div>
          <div class="w-100"></div>



          <label class="col-5 col-sm-7 col-md-3 col-lg-2 col-form-label">Tier 3 Comms</label>
          <div class="col-7 col-sm-5 col-md-3 col-lg-2">
            <div v-show="!selectedComms || selectedComms.carrier_name != c.carrier_name" class="col-form-label"> {{c.tier3_commsrate}} %</div>
            <div class="input-group"  v-show="selectedComms.carrier_name == c.carrier_name">
              <input type="text" class="form-control" v-model="selectedComms.tier3_commsrate" />
              <div class="input-group-addon">
                %
              </div>
            </div>
          </div>
          <label class="col-5 col-sm-7 col-md-3 col-lg-2 col-lg-2 offset-lg-2 col-form-label">Tier 3 Spiff</label>
          <div class="col-7 col-sm-5 col-md-3 col-lg-2">

            <div v-show="!selectedComms || selectedComms.carrier_name != c.carrier_name" class="col-form-label"> {{c.tier3_spiffrate}} %</div>
            <div class="input-group" v-show="selectedComms.carrier_name == c.carrier_name">
              <input type="text" class="form-control" v-model="selectedComms.tier3_spiffrate" />
              <div class="input-group-addon">
                %
              </div>
            </div>
          </div>
          <div class="w-100"></div>



          <label class="col-5 col-sm-7 col-md-3 col-lg-2 col-form-label">Tier 4 Comms</label>
          <div class="col-7 col-sm-5 col-md-3 col-lg-2">
            <div v-show="!selectedComms || selectedComms.carrier_name != c.carrier_name" class="col-form-label"> {{c.tier4_commsrate}} %</div>
            <div class="input-group" v-show="selectedComms.carrier_name == c.carrier_name">
              <input type="text" class="form-control" v-model="selectedComms.tier4_commsrate" />
              <div class="input-group-addon">
                %
              </div>
            </div>
          </div>
          <label class="col-5 col-sm-7 col-md-3 col-lg-2 col-lg-2  offset-lg-2 col-form-label">Tier 4 Spiff</label>
          <div class="col-7 col-sm-5 col-md-3 col-lg-2">
            <div v-show="!selectedComms || selectedComms.carrier_name != c.carrier_name" class="col-form-label"> {{c.tier4_spiffrate}} %</div>

            <div class="input-group" v-show="selectedComms.carrier_name == c.carrier_name">
              <input type="text" class="form-control" v-model="selectedComms.tier4_spiffrate" />
              <div class="input-group-addon">
                %
              </div>
            </div>
          </div>
          <div class="w-100"></div>

        </div>

      </div>

      <div class="container" v-if="!agentProfile.is_channel">
        <div class="row lined">
          <div class="col-12 col-form-label">
            <strong>Exceptions</strong>&nbsp;&nbsp;
              <dropdown-confirmation
                v-show="selectedComms.carrier_name == c.carrier_name"
                direction="left"
                triggerBtnClass="btn-light btn-sm"
                triggerBtnHtml='<i class="fa fa-plus"></i>&nbsp;&nbsp;Add'
                confirmBtnClass="btn-success"
                confirmBtnHtml='<i class="fa fa-check"></i>&nbsp;&nbsp;Save'
                @confirm="saveNewAgentOverride"
              >
              <slot>
                <div class="row">
                  <div class="col">
                    <autocomplete placeholder="Choose Agent" :list="agentNames" :selection="selectedOverrideAgentName" @change="setNewOverrideAgent"></autocomplete>
                  </div>
                </div>

                <div class="row">
                  <div class="col-4 col-form-label">Comms</div>
                  <div class="col-8">
                    <div class="input-group">
                      <input type="text" class="form-control" v-model="selectedOverrideAgent.commsrate">
                      <div class="input-group-addon">
                        %
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-4 col-form-label">Spiff</div>
                  <div class="col-8">
                    <div class="input-group">
                      <input type="text" class="form-control" v-model="selectedOverrideAgent.spiffrate">
                      <div class="input-group-addon">
                        %
                      </div>
                    </div>
                  </div>
                </div>

              </slot>
              </dropdown-confirmation>
          </div>
        </div>


          <div class="row lined dragrow" v-for="o in c.overrides" :key="o.user_id" v-show="!selectedComms || selectedComms.carrier_name != c.carrier_name">
            <label class="col-12 col-sm-3 col-md-2 col-lg-2 col-form-label">Name</label>
            <div  class="col-form-label col-12 col-sm-9 col-md-6 col-lg-4">{{o.name}}</div>
            <div class="w-100"></div>
            <label class="col-12 col-sm-7 col-md-2 col-lg-2 col-form-label">Comms</label>
            <div class="col-form-label col-12 col-sm-5">{{o.commsrate}} %</div>
            <div class="w-100"></div>
            <label class="col-12 col-sm-7 col-md-2 col-lg-2 col-form-label">Spiff</label>
            <div class="col-form-label col-12 col-sm-5">{{o.spiffrate}} %</div>
          </div>


          <draggable class="sort-container" :options="draggableOptions" :list="selectedComms.overrides" v-show="selectedComms.carrier_name == c.carrier_name">
            <div class="row lined dragrow" v-for="o, i in selectedComms.overrides" :key="o.user_id">
              <label class="col-12 col-sm-3 col-md-2 col-lg-2 col-form-label">Name</label>
              <div class="col-12 col-sm-9 col-md-6 col-lg-4">
                <autocomplete :list="agentNames" :selection="o.name" ></autocomplete>
              </div>
              <div class="w-100"></div>
              <label class="col-12 col-sm-7 col-md-2 col-lg-2 col-form-label">Comms</label>
              <div class="col-12 col-sm-5 col-md-3 col-lg-2">
                <div class="input-group">
                  <input type="text" class="form-control" v-model="o.commsrate" />
                  <div class="input-group-addon">
                    %
                  </div>
                </div>
              </div>
              <div class="w-100"></div>
              <label class="col-12 col-sm-7 col-md-2 col-lg-2 col-form-label">Spiff</label>
              <div class="col-12 col-sm-5 col-md-3 col-lg-2">
                <div class="input-group">
                  <input type="text" class="form-control" v-model="o.spiffrate" />
                  <div class="input-group-addon">
                    %
                  </div>
                </div>
              </div>

              <div class="w-100"></div>

              <div class="col-12 col-sm-7 col-md-2 col-lg-2 col-form-label">&nbsp;</div>
              <div class="col-12 col-sm-5 col-md-3 col-lg-2">
                <dropdown-confirmation
                  title="Are you sure you want to delete this exception?"
                  direction="left"
                  @confirm="deleteOverride(o, i)"></dropdown-confirmation>

              </div>
              <div class="drag-handle col-form-label">
                <svg class="svgIcon itemRow-dragIcon" viewBox="0 0 32 32" title="drag handle">
                  <path d="M 14 5.5 a 3 3 0 1 1 -3 -3 A 3 3 0 0 1 14 5.5 Z m 7 3 a 3 3 0 1 0 -3 -3 A 3 3 0 0 0 21 8.5 Z m -10 4 a 3 3 0 1 0 3 3 A 3 3 0 0 0 11 12.5 Z m 10 0 a 3 3 0 1 0 3 3 A 3 3 0 0 0 21 12.5 Z m -10 10 a 3 3 0 1 0 3 3 A 3 3 0 0 0 11 22.5 Z m 10 0 a 3 3 0 1 0 3 3 A 3 3 0 0 0 21 22.5 Z"></path>
                </svg>
              </div>

            </div>
          </draggable>
      </div>
    </div>


  </div>

</template>

<script type="text/babel">
  import Modal from '../assets/Modal.vue';
  import draggable from 'vuedraggable';
  import Dropdown from '../assets/Dropdown.vue';
  import DropdownConfirmation from '../assets/DropdownConfirmation.vue';
  import Autocomplete from '../assets/Autocomplete.vue';
  export default {
    name: 'AgentEdit',
    data: function(){
      return {
        id: '',
        selectedOverrideAgent:{
          commsrate: 0,
          name: null,
          spiffrate: 0,
          user_id: null
        },
        selectedCarrier: {},
        showAddOverride: false,
        active: '',
        agents:[],
        carriers:[],
        channels:[],
        channel: '',
        agentCommissions:[],
        selectedComms:{
          carrier_id: null,
          carrier_name: null,
          sandler_commsrate: null,
          sandler_spiffrate: null,
          tier1_commsrate: null,
          tier1_spiffrate: null,
          tier2_commsrate: null,
          tier2_spiffrate: null,
          tier3_commsrate: null,
          tier3_spiffrate: null,
          tier4_commsrate: null,
          tier4_spiffrate: null,
          overrides:[]
        },
        draggableOptions:{
          handle: ".drag-handle",
          animation: 150
        }
      }
    },
    components:{
      Dropdown,
      DropdownConfirmation,
      Autocomplete,
      draggable,
      Modal
    },
    computed:{
      agentNames(){
        return this.agents.map(function(u){
          return u.name;
        })
      },
      carrierNames(){
        return this.carriers.map(function(c){
          return c.name;
        })
      },
      selectedOverrideCarrierName(){
        return this.selectedCarrier.name;
      },
      selectedOverrideAgentName(){
        return this.selectedOverrideAgent.name;
      }

    },
    created(){
      this.id = this.agent_id || this.$route.params.agent_id;
      this.fetchAgents();
      this.fetchChannels();
      this.fetchAgentCommissions();
      this.fetchCarriers();

    },
    filters:{
      displayStatus(status){
        return (status == "1")? 'Active' : 'Inactive';
      },
      uppercase(string){
        if(!string) return null;
        return string.charAt(0).toUpperCase() + string.slice(1);

      }

    },
    methods:{
      editComms(c){
        this.selectedComms = JSON.parse(JSON.stringify(c));
      },

      deleteComms(c){
          this.$send(this, 'userCommissionsCarrierDelete', c).then(r => {
            this.fetchAgentCommissions();
          });
      },

      saveNewAgentOverride(){
        var _this = this;
        if(this.selectedOverrideAgent){
          this.selectedComms.overrides = this.selectedComms.overrides || []
          this.selectedComms.overrides.push(this.selectedOverrideAgent);
          this.selectedOverrideAgent = {
            commsrate: 0,
            name: null,
            spiffrate: 0,
            user_id: null
          }
        } else {
          alert('No carrier selected');
        }
      },
      saveNewCarrierOverride(){
        var _this = this;

        if(this.selectedCarrier.carrier_id){

            this.$send(this, 'userCommissionsCarrierCreate', {
                user_id: this.id,
                carrier_id: this.selectedCarrier.carrier_id
            }).then(r => {
                this.fetchAgentCommissions();
                this.showAddOverride = false;
                this.selectedCarrier = {};
            });

        } else {
          alert('No carrier selected');
        }

      },
      deleteOverride(parent, index){
        this.selectedComms.overrides.splice(index, 1);
      },
      setNewOverrideAgent(agent){
        var agent = this.agents.filter(function(u){
          return u.name == agent;
        })[0];
        this.selectedOverrideAgent.name = agent.name;
        this.selectedOverrideAgent.agent_id = agent.user_id;
      },
      setNewOverrideCarrier(carrier){
        this.selectedCarrier = this.carriers.filter(function(c){
          return c.name == carrier;
        })[0];

      },
      setStatus(status){

        this.selected.status = (status == 'Active') ? 1: 0;
      },
      saveInfo(){

        var data = this.selected;
        data.user_id = this.id;


          this.$send(this, 'userProfileUpdate', data).then(r => {
              this.fetchProfile();
              this.editing = null;
          });

      },
      saveComms(){
        var _this = this;
        var data = this.selectedComms;
        data.user_id = this.id;

          this.$send(this, 'userCommissionsUpdate', data).then(r => {
              this.fetchAgentCommissions();
              this.editing = null;
              this.selectedComms = {};
          });


      },
      setChannel(selection){
        this.channel = selection;
      },

      editInfo(){
        this.editing = 'info';
        this.selected = JSON.parse(JSON.stringify(this.agentProfile));
      },
      fetchAgentCommissions(){
        var _this = this;

          this.$send(this, 'userCommissions', {
              user_id: this.id
          }).then(r => {
              this.agentCommissions = [];

              if(r.userCommissions.default){
                  this.agentCommissions.push(r.userCommissions.default);
              }
              if(r.userCommissions.carriers.length){
                  this.agentCommissions = this.agentCommissions.concat(r.userCommissions.carriers);
              }
          });

      },
      fetchChannels(search){


          this.$send(this, 'channels',{
              search: search
          })

      },
      fetchAgents(){

          this.$send(this, 'userUsers').then(r => {
              this.agents = r.userUsers;
          });

      },
      fetchCarriers(){


          this.$send(this, 'carriers').then(r => {
              this.carriers = r.carriers;
          });

      },
      setActive(carrier){

        this.selectedComms = {};
        this.active = (this.active != carrier.carrier_name) ? carrier.carrier_name : null;


      },
      isActive(carrier){
        if(!carrier) return false;
        return this.active == carrier.carrier_name;
      }
    },
    mounted(){

    },
    props:['agentProfile', 'agent_id']
  }
</script>

<style>
  .row{
    position: relative;
  }
  .commission-section {
    padding: 10px 15px;
    border: 1px solid #e2e2e2;
    border-bottom: none;
    background: #f9f9f9;
  }

  .commission-section:last-child{
    border-bottom: 1px solid #e2e2e2;
  }
  .commission-section.active {
    background: #f0f7fc;
    border: 1px solid #aabcca;
  }

  .commission-section .section-header{
    cursor: pointer;
  }


  .commission-section .section-header i{
    -webkit-transition: .25s ease-in-out;
    -moz-transition: .25s ease-in-out;
    -o-transition: .25s ease-in-out;
  }
  .commission-section.active .section-header i{
    -ms-transform: rotate(90deg); /* IE 9 */
    -webkit-transform: rotate(90deg); /* Chrome, Safari, Opera */
    transform: rotate(90deg);
  }
  .commission-section.active .section-header{

    margin-bottom: 20px;
  }

  .commission-section .container{
    display: none;
    width: 100%;
  }
  .commission-section.active .container{
    display: block;
  }

  .row>.col.col-form-label,
  .row>[class^=col-].col-form-label{
    padding-top: 10px;
  }


  .drag-handle.col-form-label {
    width: 10px;
    color: #cccccc;
    padding: 15px 10px 15px 0;
    cursor: move;
    margin-right: 15px;
    position: absolute;
    left: -11px;
    top: 50%;
    height: 35px;
    margin-top: -18px;
    opacity: .25;
  }
  .drag-handle i {
    margin: 0;
    padding: 0;
    font-size: 8px;
    line-height: 8px;
    margin-bottom: -15px;
    display: block;
  }
  .dragrow{
    background: white;
  }
  .sortable-ghost.sortable-chosen{
    background: #ccc;
    opacity:.25;
  }
  .sortable-drag{
    border: 1px solid #ccc;

    overflow: visible;
  }

  svg.svgIcon {
    width: 16px;
    height: 16px;
    color: #ccc;
  }
  .row.lined.dragrow:last-child{
    border-bottom: none;
  }

  .row.comm-tiers{
    border-top: 1px solid #e2e2e2;
  }






</style>



// WEBPACK FOOTER //
// AgentCommissions.vue?9f40bd38